import { SuperName, jtString } from '@standardnotes/features';
import { c } from 'ttag';
export var FeatureName;
(function (FeatureName) {
    FeatureName["Files"] = "Files";
    FeatureName["Super"] = "Super";
})(FeatureName || (FeatureName = {}));
export function getFeatureNameLabel(feature) {
    switch (feature) {
        case FeatureName.Files:
            return c('B7.FilesSubscriptionHelp.Subscription.Label').t `Encrypted File Storage`;
        case FeatureName.Super:
            return jtString(c('B7.FilesSubscriptionHelp.Subscription.Label').jt `${SuperName} notes`);
    }
}
